import React from 'react';
import { Link } from 'react-router-dom';
import useDocumentMeta from './useDocumentMeta';

function Terms() {
    useDocumentMeta({
        title: 'Terms of Use | Yay Fun, Inc.',
        description: 'Terms of use for the Yay Fun, Inc. website.',
        path: '/terms',
    });

    return (
        <section className="legal" id="legal">
            <div className="container legal__body">
                <h1>Terms of Use</h1>
                <p className="legal__updated">Last updated: October 15, 2026</p>

                <p>
                    These terms apply to your use of yayfuninc.com, the website of Yay Fun, Inc.
                    (“Yay Fun,” “we,” “us”). By using this site, you agree to these terms.
                </p>

                <h2>Our products</h2>
                <p>
                    Our products, such as PokeSwift and Social Bellow, may have their own terms of
                    service. Those terms apply when you use those products.
                </p>

                <h2>Content on this site</h2>
                <p>
                    The text, images, logos, and other content on this site belong to Yay Fun, Inc. or are
                    used with permission. Please don’t copy or reuse them without our written permission.
                    Other company and product names, such as Adobe Express, Canva, App Store, and Google
                    Play, are trademarks of their respective owners.
                </p>

                <h2>Acceptable use</h2>
                <p>
                    Please don’t misuse this site, including by attempting to disrupt it or gain
                    unauthorized access.
                </p>

                <h2>Links to other sites</h2>
                <p>
                    This site links to websites we don’t control, such as app stores and partner platforms.
                    We aren’t responsible for their content or practices.
                </p>

                <h2>No warranties</h2>
                <p>
                    This site is provided “as is.” We work to keep it accurate and available, but we don’t
                    guarantee that it will always be error-free or uninterrupted. To the fullest extent
                    permitted by law, Yay Fun, Inc. is not liable for any damages arising from your use of
                    this site.
                </p>

                <h2>Privacy</h2>
                <p>
                    Our <Link to="/privacy">Privacy Policy</Link> explains how we handle information
                    collected through this site.
                </p>

                <h2>Governing law</h2>
                <p>
                    These terms are governed by the laws of the State of Texas, United States, without
                    regard to its conflict of law provisions.
                </p>

                <h2>Changes</h2>
                <p>
                    We may update these terms from time to time. The date above shows when they were last changed.
                </p>

                <h2>Contact us</h2>
                <p>
                    Questions about these terms? Email <a href="mailto:contact@yayfuninc.com">contact@yayfuninc.com</a>.
                </p>
            </div>
        </section>
    )
}

export default Terms
